export default __webpack_public_path__ + "static/media/479.47c125e6.png";